<template>
<div class="content">
  <div class="header">
    <el-button @click="openDev">数据检查</el-button>
    <el-button @click="openDev">数据导入</el-button>
    <el-button @click="setComponents('CustomerRentMain')">返回</el-button>
  </div>
  <div class="header-btn">
    <el-descriptions size="mini" :column="1" border :label-style="{width: '100px'}">
      <el-descriptions-item label="房产">
        {{where.house_name}}
      </el-descriptions-item>
      <el-descriptions-item label="下载模板">
        <el-button @click="openDev">下载</el-button>
      </el-descriptions-item>
      <el-descriptions-item label="上传模板">
        <el-button @click="openDev">上传</el-button>
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <div class="body">
    <div style="display: flex;flex-direction: row;margin-top: 20px;">
      <div>
        <el-link @click="table_where_name=''">总条数： <span style="color: #038dce">{{excel_list_num}}</span> 条</el-link>
      </div>
<!--      <div style="margin-left: 50px">-->
<!--        插入条数： <span style="color: #ff3d00">{{excel_list_insert_num}}</span> 条-->
<!--      </div>-->
<!--      <div style="margin-left: 50px">-->
<!--        修改条数： <span style="color: #ff3d00">{{excel_list_num-excel_list_insert_num}}</span> 条-->
<!--      </div>-->
<!--      <div style="margin-left: 50px">-->
<!--        <el-link @click="table_where_name='is_repeated'">编号重复条数： <span style="color: #ff3d00">{{excel_list_repeated_num}}</span> 条(编号重复的标红)</el-link>-->
<!--      </div>-->
<!--      <div style="margin-left: 50px" >-->
<!--        <el-link @click="table_where_name='is_project'">房产项目不正确条数： <span style="color: #ff3d00">{{excel_list_is_project_num}}</span> 条(编号重复的标黄)</el-link>-->
<!--      </div>-->
    </div>
    <el-table class="table-wrap2" v-loading="loading" :data="pageData.list" :row-class-name="tableRowClassName">
      <el-table-column
        type="index"
        width="50">
      </el-table-column>
      <el-table-column prop="房号" label="房号" align="center" width="320"></el-table-column>
      <el-table-column prop="租户姓名" label="租户姓名" align="center" width="100"></el-table-column>
      <el-table-column prop="客户性质" label="客户性质" align="center" width="100"></el-table-column>
      <el-table-column prop="证件类型" label="证件类型" align="center" width="100"></el-table-column>
      <el-table-column prop="身份证号" label="身份证号" align="center" width="100"></el-table-column>
      <el-table-column prop="手机号码" label="手机号码" align="center" width="120"></el-table-column>
      <el-table-column prop="承租日期" label="承租日期" align="center" width="120"></el-table-column>
      <el-table-column prop="上家退租日期" label="上家退租日期" align="center" width="180"></el-table-column>
    </el-table>
    <div style="margin-top: 20px;text-align: right;margin-right: 20px;">
      <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
    </div>



  </div>
</div>
</template>

<script>
export default {
  name: "CustomerRentBatch",
  inject:["mainObj","setComponentsId"],
  data(){
    return{
      where:{
        house_id:"",
        house_name:"",
      },
      loading:false,
      excel_list:[],
      pageData:{
        list:[],
        total: 0,
        pageSize: 15,
        page: 1
      },
      table_where_name:""
    }
  },
  activated() {
    this.where.house_id=this.house_id;
    this.where.house_name=this.house_name;
    // this.getRent()
  },
  watch:{
    house_name(n,o){
      this.where.house_name=n;
    },
    house_id(n,o){
      this.where.house_id=n;
    }
  },
  computed:{
    house_name(){
      return this.mainObj.house_name
    },
    house_id(){
      return this.mainObj.house_id
    },
    excel_list_num(){
      return this.excel_list.length
    }
  },
  methods:{
    setComponents(componentsId){
      this.setComponentsId(componentsId)
    },
    tableRowClassName({row, rowIndex}) {
      const that=this;
      if (row.is_repeated) {
        return 'warning-row';
      }else if (row.is_project) {
        return 'project-row';
      }else {
        return "success-row"
      }
    },
    dowExcel(){
      if(this.where.house_name == ''){
        this.$Message.error('点击左边树选择项目!');
        return false;
      }
      var that=this;
      let where=reObject(that.where);
      ERP.showLoading()
      ERP.getRequest({
        url:"admin/Meter/MeterExportExcel",
        data:{
          where:JSON.stringify(where),
          user_type:(that.$route.query.type||0),
        }
      },ret=>{
        ERP.hideLoading()
        if(ret.code){
          window.open(__HTTP__.defaults.baseURL +ret.data)
        }
      },err=>{
        ERP.hideLoading()
        this.$Message.error('请求异常!');
      });
    },
    showExcel() {
      var that=this;
      that.loading=true;
      if(!that.excel_file){
        this.$message.error('请提交Excel表单');
        return false;
      }
      ERP.postRequest({
        url:"admin/Meter/meterImportExcelShow",
        data:{
          file:that.excel_file,
        }
      },res=>{
        if(res.code) {
          that.excel_list=res.data
          that.pageData.total=that.excel_list.length
          that.pageChange(1)
        }else {
          that.$message.error(res.msg||"表格解析异常");
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i
      let list=reObject(that.excel_list)
      if(that.table_where_name){
        list=reObject(that.excel_list.filter(ret=>!!ret[that.table_where_name]))
      }
      that.pageData.list=list.splice((that.pageData.page-1)*that.pageData.pageSize,that.pageData.pageSize);
    },
    openDev(){
      this.$message.error("待开发……")
    }
  }
}
</script>

<style lang="scss" scoped>
.content{

}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/CustomerRentBatch.vue